import { render } from "./Pricing.vue?vue&type=template&id=22611659&scoped=true"
const script = {}

import "./Pricing.vue?vue&type=style&index=0&id=22611659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22611659"]])

export default __exports__